<template >
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            :title="modalDescr"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData()"
          ></i>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header pastel-green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              {{ modalDescr }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="inputName"
                      class="form-control"
                      placeholder="Name"
                      autofocus="autofocus"
                      v-model="productLoyalty.name"
                      v-on:input="$v.productLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyalty.name.$error,
                        valid:
                          $v.productLoyalty.name.$dirty &&
                          !$v.productLoyalty.name.$invalid,
                      }"
                    />
                    <label for="inputName">დასახელება</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="number"
                      id="parameter1"
                      class="form-control"
                      placeholder="დღგ VAT"
                      v-model="productLoyalty.parameter1"
                      v-on:input="$v.productLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyalty.parameter1.$error,
                        valid:
                          $v.productLoyalty.parameter1.$dirty &&
                          !$v.productLoyalty.parameter1.$invalid,
                      }"
                    />
                    <label for="parameter1">დღგ VAT %</label>
                  </div>
                  <div class="form-group form-check mt-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="status"
                      v-on:input="$v.productLoyalty.$touch"
                      v-model="productLoyalty.status"
                    />
                    <label class="form-check-label" for="status"
                      >პირობის გააქტიურება</label
                    >
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="parameter2"
                      class="form-control"
                      placeholder="ვიშერის მარჟა M"
                      v-model="productLoyalty.parameter2"
                      v-on:input="$v.productLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyalty.parameter2.$error,
                        valid:
                          $v.productLoyalty.parameter2.$dirty &&
                          !$v.productLoyalty.parameter2.$invalid,
                      }"
                    />
                    <label for="parameter2">ვიშერის მარჟა M %</label>
                  </div>
                </div>
                <div class="form-label-group mt-3">
                  <input
                    type="number"
                    id="parameter3"
                    class="form-control"
                    placeholder="ქულის სდანდარტული ღირებულება"
                    v-model="productLoyalty.parameter3"
                    v-on:input="$v.productLoyalty.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyalty.parameter3.$error,
                      valid:
                        $v.productLoyalty.parameter3.$dirty &&
                        !$v.productLoyalty.parameter3.$invalid,
                    }"
                  />
                  <label for="parameter3">ქულის სდანდარტული ღირებულება</label>
                </div>
                <div class="form-label-group mt-3">
                  <input
                    type="number"
                    id="parameter4"
                    class="form-control"
                    placeholder="ფასდაკლება %"
                    v-model="productLoyalty.parameter4"
                    v-on:input="$v.productLoyalty.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyalty.parameter4.$error,
                      valid:
                        $v.productLoyalty.parameter4.$dirty &&
                        !$v.productLoyalty.parameter4.$invalid,
                    }"
                  />
                  <label for="parameter4">ფასდაკლება %</label>
                </div>
                <div class="form-label-group mt-3">
                  <input
                    type="number"
                    id="parameter5"
                    class="form-control"
                    placeholder="დამატებითი პარამეტრი"
                    v-model="productLoyalty.parameter5"
                    v-on:input="$v.productLoyalty.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyalty.parameter5.$error,
                      valid:
                        $v.productLoyalty.parameter5.$dirty &&
                        !$v.productLoyalty.parameter5.$invalid,
                    }"
                  />
                  <label for="parameter5">დამატებითი პარამეტრი</label>
                </div>
              </form>
              <form class="col-12 col-md-12">
                <textarea
                  id="inputInfo"
                  class="form-control"
                  style="height: 100px; margin-top: 15px"
                  placeholder="დამატებითი ინფორმაცია"
                  autofocus="autofocus"
                  v-model="productLoyalty.info"
                  v-on:input="$v.productLoyalty.$touch"
                  v-bind:class="{
                    'error-border': $v.productLoyalty.info.$error,
                    valid:
                      $v.productLoyalty.info.$dirty &&
                      !$v.productLoyalty.info.$invalid,
                  }"
                />
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.productLoyalty.$dirty || $v.productLoyalty.$error"
              @click="$v.productLoyalty.$touch(), addOrEditProductLoyalty()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">დასახელება</th>
            <th class="numeric">დღგ VAT %</th>
            <th class="numeric">ვიშერის მარჟა M %</th>
            <th class="numeric">ქულის სდანდარტული ღირებულება</th>
            <th class="numeric">ფასდაკლება %</th>
            <th class="numeric">დამატებითი პარამეტრი</th>
            <th class="numeric">პირობის სტატუსი</th>
            <th class="numeric">დამატებითი ინფორმაცია</th>
            <th class="numeric">რედაქტირება</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in array" :key="value.id">
            <td data-title="დასახელება" class="numeric">{{ value.name }}</td>
            <td data-title="დღგ VAT %" class="numeric">
              {{ value.parameter1 }}
            </td>
            <td data-title="ვიშერის მარჟა M %" class="numeric">
              {{ value.parameter2 }}
            </td>
            <td data-title="ქულის სდანდარტული ღირებულება" class="numeric">
              {{ value.parameter3 }}
            </td>
            <td data-title="ფასდაკლება %" class="numeric">
              {{ value.parameter4 }}
            </td>
            <td data-title="დამატებითი პარამეტრი" class="numeric">
              {{ value.parameter5 }}
            </td>
            <td data-title="პირობის სტატუსი" class="text">
              {{ value.status ? "აქტიურია" : "არააქტიურია" }}
            </td>
            <td data-title="დამატებითი ინფორმაცია" class="text">
              {{ value.info }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="editProductLoyalty(value)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "productLoyalty",
  data() {
    return {
      showModal: false,
      productLoyalty: {
        id: "",
        name: "",
        parameter1: 18,
        parameter2: 20,
        parameter3: 1.34,
        parameter4: "",
        parameter5: "",
        status: false,
        info: "",
      },
      lastID: 14,
      isActive: false,
      array: "",
      modalDescr: "პროდუქტის ლოიალობის პირობების დამატება",
      isEditMode: false,
    };
  },
  validations: {
    productLoyalty: {
      name: {
        required,
      },
      parameter1: {
        required,
      },
      parameter2: {
        required,
      },
      parameter3: {
        required,
      },
      parameter4: {
        required,
      },
      parameter5: {
        required,
      },
      status: {
        required,
      },
      info: {
        required,
      },
    },
  },
  async created() {
    let productLoyaltiesResult = await this.$http.getProductLoyalties();
    this.array = productLoyaltiesResult.data.res;
  },
  methods: {
    async addOrEditProductLoyalty() {
      if (this.isEditMode) {
        //რედაქტირება
        try {
          let editProductLoyaltyResult = await this.$http.putProductLoyalty(
            this.productLoyalty
          );

          if (editProductLoyaltyResult.data.resultCode === "200") {
            bus.$emit(
              "success",
              "პროდუქტის ლოიალობის პირობები წარმატებით შეიცვალა"
            );

            let productLoyaltiesResult = await this.$http.getProductLoyalties();
            this.array = productLoyaltiesResult.data.res;
          } else {
            bus.$emit(
              "warning",
              "პროდუქტის ლოიალობის პირობების შეიცვლის დროს მოხდა შეცდომა"
            );
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      } else {
        //ახლის დამატება
        try {
          let addProductLoyaltyResult = await this.$http.postProductLoyalty(
            this.productLoyalty
          );

          if (addProductLoyaltyResult.data.resultCode === "200") {
            bus.$emit(
              "success",
              "პროდუქტის ლოიალობის პირობები წარმატებით დაემატა"
            );

            let productLoyaltiesResult = await this.$http.getProductLoyalties();
            this.array = productLoyaltiesResult.data.res;
          } else {
            bus.$emit(
              "warning",
              "პროდუქტის ლოიალობის პირობების დამატების დროს მოხდა შეცდომა"
            );
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      }
      this.isEditMode = false;
    },
    editProductLoyalty(row) {
      this.productLoyalty = Object.assign({}, row);
      this.modalDescr = "პროდუქტის ლოიალობის პირობების რედაქტირება";

      this.isEditMode = true;
      //let editIndex = this.array.findIndex(
      // (d) => d.id === this.organizations.id
      //);
      //this.$set(this.array, editIndex, Object.assign({}, this.organizations));
    },
    editFillInputs(row) {
      this.organizations = Object.assign({}, row);
    },
    clearData() {
      this.productLoyalty.id = null;
      this.productLoyalty.name = "";
      this.productLoyalty.parameter1 = 18;
      this.productLoyalty.parameter2 = 20;
      this.productLoyalty.parameter3 = 1.34;
      this.productLoyalty.parameter4 = "";
      this.productLoyalty.parameter5 = "";
      this.productLoyalty.status = false;
      this.productLoyalty.info = "";
      this.modalDescr = "პროდუქტის ლოიალობის პირობების დამატება";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ProductLoyalty.vue